'use strict';

import {StructureSectionsNavigCtrl} from './structuresectionsnavigctrl.js';

export class InvitationStructureSectionsNavigCtrl extends StructureSectionsNavigCtrl
{

	
	constructor($scope, jsDataService){
		super($scope, jsDataService);
	}
	
	isAction(node){
		return ((typeof(node.has_fields) !== 'undefined' && node.has_fields) || (typeof(node.has_instructions) !== 'undefined' && node.has_instructions));
	}
	
}